import { render, staticRenderFns } from "./ActionButtons.vue?vue&type=template&id=34f780d5&scoped=true"
import script from "./ActionButtons.vue?vue&type=script&lang=ts"
export * from "./ActionButtons.vue?vue&type=script&lang=ts"
import style0 from "./ActionButtons.vue?vue&type=style&index=0&id=34f780d5&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f780d5",
  null
  
)

export default component.exports